/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.UpsellOpportunities {
    angular.module("meevo.plugins.upsellOpportunities", [])
        .run(['webComponentSetup', 'meevo.components.tracking.TrackingService',
            '$rootScope', 'meevo.AppSettings', 'webComponentMountHooks',
            function (
                webComponentSetup: any,
                trackingService: Meevo.Components.Tracking.ITrackingService,
                $rootScope: angular.IRootScopeService,
                appSettings: any,
                webComponentMountHooks: any
            ) {
                webComponentSetup.register({
                    id: 'meevo-offer-builder',
                    tag: 'meevo-offer-builder'
                });

                // Forward the web component's "offer-viewed" CustomEvent to the host's tracking service.
                // The web component dispatches with bubbles+composed so the event escapes the shadow root.
                // (Host shell is on TS 2.3, so no optional chaining or generic CustomEvent.)
                document.addEventListener('offer-viewed', (e: Event) => {
                    var detail = (e as any).detail as { offerId: string } | undefined;
                    if (detail && detail.offerId) {
                        trackingService.savePageView(
                            Meevo.Model.NounEnum.UpsellOpportunityMain,
                            undefined,
                            new Meevo.Guid(detail.offerId)
                        );
                    }
                });

                // Forward the web component's "ai-suggestions-viewed" CustomEvent. This is a
                // page view, not an entity view, so no main entity id is passed
                document.addEventListener('ai-suggestions-viewed', () => {
                    trackingService.savePageView(Meevo.Model.NounEnum.UpsellOpportunityAISuggestions);
                });

                // Tab-close guard: the Shell and the Offer Builder web component run in
                // separate injectors, so the Shell can't query the component's dirty state
                // directly. Instead it asks the mounted element to decide (request-close);
                // the component runs its existing unsaved-changes guard (same one used for
                // in-app navigation) and only replies (closeConfirmed) once it's actually
                // safe to close. Cancel or a failed Save reply with nothing, so the tab
                // simply stays open — see offer-builder.component.ts / offer-builder-state.service.ts.
                var mountedElement: HTMLElement = null;
                var pendingCloseState: any = null;

                webComponentMountHooks.register('meevo-offer-builder', (element: HTMLElement) => {
                    mountedElement = element;
                    element.addEventListener('closeConfirmed', () => {
                        if (!pendingCloseState) return;
                        $rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, pendingCloseState);
                        pendingCloseState = null;
                    });
                });
                webComponentMountHooks.registerUnmount('meevo-offer-builder', () => {
                    mountedElement = null;
                });

                $rootScope.$on(Meevo.Components.Common.Messages.CLOSE_CONTEXT_WARNING, (event: angular.IAngularEvent, state: any) => {
                    if (state.name !== appSettings.ROUTE_NAMES.upsellOpportunities) return;
                    pendingCloseState = state;
                    if (mountedElement) {
                        mountedElement.dispatchEvent(new CustomEvent('request-close'));
                    } else {
                        // Nothing mounted — shouldn't happen while the tab is open, but fail
                        // open rather than leave the tab stuck with no way to close it.
                        $rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, state);
                        pendingCloseState = null;
                    }
                });
            }]);
}
